export const content = state => state.content
export const types = state => state.types
export const tags = state => state.tags
export const actions = state => state.actions
export const roles = state => state.roles
// types
export const getContentTypes = function (state) {
  let defaultValue = false
  return state.types.map(function (type) {
    if (!defaultValue) {
      return
    }
    return {
      'label': type.type,
      'value': type.id
    }
  })
}
export const getContentTypeTitles = (state) => state.types.map(item => item.type)
export const getContentTypeIdByTitle = (state) => (type) => state.types.find(item => item.type === type).id
export const getContentTypeForSelect = (state) => state.types.map(item => {
//  if (item.is_active) {
  return {
    label: item.type,
    value: item.id
  }
//  }
})
export const getContentChapterForSelect = (state) => state.chapters.map(item => {
//  if (item.is_active) {
  return {
    label: item.name,
    value: item.id
  }
//  }
})

// tags
export const getTagTitles = (state) => state.tags.map(item => {
  return {
    'label': item.name,
    'value': item.id
  }
})
export const getTagIdByNames = (state) => (names) => state.tags.filter(item => names.indexOf(item.name) !== -1).map(item => item.id)
export const getTagsForSelect = (state) => state.tags.map(item => {
//  if (item.is_active) {
  return {
    label: item.name,
    value: item.id
  }
//  }
})
export const getNonEmptyTagsForSelect = (state) => state.tags.filter(item => parseInt(item.contentsCount) > 0).map(item => {
  return {
    label: item.name,
    value: item.id
  }
})

// auth
export const getIsLoggedIn = (state) => state.auth.isLoggedIn
export const getFirstName = (state) => state.auth.userData ? state.auth.userData.firstName : ''
export const getLastName = (state) => state.auth.userData ? state.auth.userData.lastName : ''
export const getUserId = (state) => state.auth.userData ? state.auth.userData.id : ''
export const getUserRole = (state) => state.auth.userData ? state.auth.userData.userRole : null
export const getUserCompany = (state) => state.auth.userData ? state.auth.userData.company : null
export const getAccessToken = state => state.auth.accessToken
export const getTest = (state) => state.auth
export const isAdmin = (state) => state.auth.userData ? state.auth.userData.userRole === 'gm' : false
export const isRegularUser = (state) => state.auth.userData ? ['ca', 'cu'].indexOf(state.auth.userData.userRole) > -1 : false
export const isLightUser = (state) => state.auth.userData ? ['la', 'lu', 'ta', 'tu'].indexOf(state.auth.userData.userRole) > -1 : false
export const companyName = (state) => state.auth.companyName

// categories
export const getCategoriesTitle = (state) => state.categories.map(item => item.title)
export const getCategoriesForSelect = (state) => state.categories.map(item => {
//  if (item.is_active) {
  return {
    label: item.title,
    value: item.id,
    level: item.parent ? 2 : 1
  }
//  }
})
export const getNonEmptyCategoriesForSelect = (state) => state.categories.filter(item => item.contents && item.contents.length).map(item => {
  return {
    label: item.title,
    value: item.id,
    level: item.parent ? 2 : 1
  }
})
export const parentCategoriesForSelect = (state) => state.categories
  .filter(item => !item.parent)
  .map(item => {
    return {
      label: item.title,
      value: item.id
    }
  })
// companies
export const getCompaniesForSelect = (state) => state.companies.map(item => {
  return {
    label: item.parent ? ' - ' + item.name : item.name,
    value: item.id,
    parent: item.parent ? 1 : 0,
    usersLimit: item.employee_limit ? item.employee_limit : 0
  }
})
// industries
export const getIndustriesForSelect = (state) => state.industries.map(item => {
  return {
    label: item.parent ? ' - ' + item.name : item.name,
    value: item.id,
    parent: item.parent ? 1 : 0
  }
})
// industries
export const getDefaultRegistrationRolesForSelect = (state) => state.defaultRegistrationRoles.map(item => {
  return {
    label: item.name,
    value: item.id
  }
})
// get sponsor list
export const getSponsorList = (state) => state.sponsors.map(item => {
  return {
    id: item.id,
    alt: item.alt ? item.alt : '',
    url: item.url ? item.url : '',
    logo: item.logo ? item.logo : '',
    order: item.order ? item.order : '',
    isLogoFileUploaded: true
  }
})
// roles
export const getRolesForSelect = (state) => state.roles.map(item => {
//  if (item.is_active) {
  return {
    label: item.name,
    slug: item.slug,
    value: item.id
  }
//  }
})
// languages
export const getLanguagesForSelect = (state) => state.languages.map(item => {
//  if (item.is_active) {
  return {
    label: item.name,
    value: item.id
  }
//  }
})
export const getArticlePreview = (state) => state.articlePreview

export const getConfData = (state) => state.confData

export const getInformationMsg = (state) => state.informationMsg

// Special opportunities
export const getSelectedFontSize = (state) => state.specialOps.fontOpt[state.specialOps.selectedFont]
export const getSelectedFont = (state) => state.specialOps.selectedFont

export const selectedHightCont = (state) => state.specialOps.selectedHightCont
export const bgColorSpOp = (state) => state.specialOps.backgroundColor[state.specialOps.selectedHightCont]
export const color = (state) => state.specialOps.color[state.specialOps.selectedHightCont]
export const whiteYelWhite = (state) => {
  let color
  switch (state.specialOps.selectedHightCont) {
    case 0:
      color = '#fff'
      break
    case 1:
      color = '#FFFA1A'
      break
    case 2:
      color = '#fff'
      break
  }
  return {
    color
  }
}
export const blackYelBlack = (state) => {
  let color
  switch (state.specialOps.selectedHightCont) {
    case 0:
      color = '#000'
      break
    case 1:
      color = '#FFFA1A'
      break
    case 2:
      color = '#000'
      break
  }
  return {
    color
  }
}
export const BlueYelBlue = (state) => {
  let color
  switch (state.specialOps.selectedHightCont) {
    case 0:
      color = '#257281'
      break
    case 1:
      color = '#FFFA1A'
      break
    case 2:
      color = '#257281'
      break
  }
  return {
    color
  }
}

export const getConsentRequired = (state) => state.consentRequired

export const getImpersonatingUser = (state) => state.impersonatingUser

export const tasksPriorities = (state) => state.tasks.priorities

export const taskMessageAllowedFileFormats = (state) => state.tasks.message.allowedFileFormats

export const chapters = (state) => state.chapters

export const taskChapters = (state) => state.taskChapters

export const taskStatuses = (state) => state.taskStatuses

export const taskStatusesForSelect = (state) => state.taskStatuses.map(item => {
  return {
    label: item.name,
    value: item.id
  }
})

export const taskAssigneeForSelect = (state) => {
  return [
    {
      label: 'Unassigned',
      value: null
    },
    ...state.taskAssignee
  ]
}

export const defaultAssigneeForSelect = (state) => state.taskAssignee

export const adminUsersForSelect = (state) => state.adminUsers

export const taskAssignee = (state) => state.taskAssignee.filter((item) => item.count > 0)

export const backlogTasks = (state) => state.tasks.backlogTasks

export const focusTasks = (state) => state.tasks.focusTasks

export const articleCategories = (state) => state.categories.filter(item => item.contents && item.contents.length).map(item => {
  return {
    id: item.id,
    title: item.title,
    description: item.description,
    icon: item.icon
  }
})

export const articleTopics = (state) => state.tags.filter(item => parseInt(item.contentsCount) > 0).map(item => {
  return {
    id: item.id,
    title: item.name,
    description: item.description,
    icon: item.icon
  }
})

export const companySizes = (state) => state.companySizes.map(item => {
  return {
    value: item.id,
    label: item.name
  }
})

export const companyLocations = (state) => state.companyLocations.map(item => {
  return {
    value: item.id,
    label: item.name
  }
})



// WEBPACK FOOTER //
// ./src/store/getters.js